import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import { Box, Button, IconButton, Tooltip } from "@mui/material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { mkConfig, generateCsv, download } from "export-to-csv";
import "react-toastify/dist/ReactToastify.css";
import EditIcon from "@mui/icons-material/Edit";
import { Delete } from "@mui/icons-material";
import MonthYearPicker from "../../pages/partnerInvoice/MonthYearPicker";
import ToastComponent from "./ToastComponent";
import { useMediaQuery, useTheme } from "@mui/material";
import { useSelector } from "react-redux";

const csvConfig = mkConfig({
  fieldSeparator: ",",
  decimalSeparator: ".",
  useKeysAsHeaders: true,
});

const CustomTable = ({
  columns,
  data,
  showRowAction = false,
  DataForExportAll,
  showMonthYearPicker = false,
  onMonthYearChange,
  loading = false,
  permissionKey,
  partnerInvoiceUrl,
}) => {
  // this is only for month and year selector in partner Invoice
  const handleMonthYearChange = (value) => {
    if (onMonthYearChange) {
      onMonthYearChange(value);
    }
  };
  // end

  if (!data) {
    data = [];
  }
  if (!DataForExportAll) {
    DataForExportAll = data;
  }
  // const handleExportRows = (rows) => {
  //   const rowData = rows.map((row) => row.original);
  //   const csv = generateCsv(csvConfig)(rowData);
  //   download(csvConfig)(csv);
  // };

  //-------------logic for show export all data----------

  const rolePermissions = useSelector((state) => state.login.login.role);

  // const canExport = rolePermissions?.AdminEmployee?.export === 1;
  const canExport = rolePermissions?.[permissionKey]?.export === 1;

  //-------------------$$----------------------------------

  //-------------------handle export rows---------------------
  const handleExportRows = () => {
    const selectedRows = table.getSelectedRowModel().flatRows;

    const visibleColumns = table
      .getVisibleLeafColumns()
      .filter(
        (col) => col.id !== "mrt-row-select" && col.id !== "mrt-row-actions",
      );

    const rowData = selectedRows.map((row) => {
      const obj = {};
      visibleColumns.forEach((col) => {
        obj[col.columnDef.header] = row.getValue(col.id);
      });
      return obj;
    });

    console.log("Final Export Data:", rowData);

    const csv = generateCsv(csvConfig)(rowData);
    download(csvConfig)(csv);
  };

  //-------------------------$$-----------------------------

  // const handleExportData = () => {
  //   // const csv = generateCsv(csvConfig)(data);
  //   console.log("dishant================>>", DataForExportAll)

  //   const csv = generateCsv(csvConfig)(DataForExportAll);
  //   download(csvConfig)(csv);
  // };
  //----------------------$--------------------------------
  // const handleExportData = () => {
  //   const rowData = table.getPrePaginationRowModel().rows.map((row) =>
  //     row.getAllCells().reduce((acc, cell) => {
  //       acc[cell.column.columnDef.header] = cell.getValue();
  //       return acc;
  //     }, {})
  //   );

  //   const csv = generateCsv(csvConfig)(rowData);
  //   download(csvConfig)(csv);
  // };

  // const handleExportData = () => {
  //   const visibleColumns = table
  //     .getAllLeafColumns()
  //     .filter((col) => col.getIsVisible());

  //   const rowData = table.getPrePaginationRowModel().rows.map((row) => {
  //     const obj = {};
  //     visibleColumns.forEach((col) => {
  //       obj[col.columnDef.header] = row.getValue(col.id);
  //     });
  //     return obj;
  //   });

  //   const csv = generateCsv(csvConfig)(rowData);
  //   download(csvConfig)(csv);
  // };

  const handleExportData = () => {
    const visibleColumns = table
      .getVisibleLeafColumns()
      .filter(
        (col) => col.id !== "mrt-row-select" && col.id !== "mrt-row-actions",
      );

    const rowData = table.getPrePaginationRowModel().rows.map((row) => {
      const obj = {};
      visibleColumns.forEach((col) => {
        obj[col.columnDef.header] = row.getValue(col.id);
      });
      return obj;
    });

    const csv = generateCsv(csvConfig)(rowData);
    download(csvConfig)(csv);
  };

  //-----------------------$-------------------------------

  //   const handleExportData = () => {
  //   if (!Array.isArray(DataForExportAll) || DataForExportAll.length === 0) {
  //     console.warn("No data available for export");
  //     return;
  //   }

  //   const csv = generateCsv(csvConfig)(DataForExportAll);
  //   download(csvConfig)(csv);
  // };

  const table = useMaterialReactTable({
    columns,
    data,
    state: {
      isLoading: loading, // <--- Use this built-in prop for loading state
    },

    initialState: { density: "compact" },
    enableRowSelection: true,
    columnFilterDisplayMode: "popover",
    paginationDisplayMode: "pages",
    positionToolbarAlertBanner: "bottom",
    // enableRowActions: true,
    enableRowActions: showRowAction,
    positionActionsColumn: "last",
    enableGlobalFilter: true,
    maxSize: 100,

    muiTableHeadCellProps: {
      sx: () => ({
        background: "#DCDAFF",
        fontWeight: "normal",
      }),
    },
    // renderRowActions: ({ cell, row, table }) => [
    //   // Add your row actions here
    // ],

    renderRowActions: ({ cell, row, table }) => [
      <>
        <Box display="flex" flexDirection="row" alignItems="center">
          <Tooltip title="Edit User">
            <IconButton>
              {/* <IconButton onClick={() => handleOpen(row.original)}> */}
              <EditIcon />
            </IconButton>
          </Tooltip>
          <Tooltip title="Delete">
            <IconButton>
              {/* <IconButton onClick={() => handleBlockUser(row.original)}> */}
              <Delete />
            </IconButton>
          </Tooltip>
        </Box>
      </>,
    ],
    renderTopToolbarCustomActions: ({ table }) => (
      <Box
        sx={{
          display: "flex",
          gap: "16px",
          padding: "8px",
          flexWrap: "wrap",
        }}
      >
        {!isMobile && canExport && (
          <Button onClick={handleExportData} startIcon={<FileDownloadIcon />}>
            Export All Data
          </Button>
        )}
        {!isMobile && canExport && (
          <Button
            disabled={
              !table.getIsSomeRowsSelected() && !table.getIsAllRowsSelected()
            }
            onClick={() => handleExportRows(table.getSelectedRowModel().rows)}
            startIcon={<FileDownloadIcon />}
          >
            Export Selected Rows
          </Button>
        )}
        {showMonthYearPicker && (
          <MonthYearPicker
            onChange={handleMonthYearChange}
            partnerInvoiceUrl={partnerInvoiceUrl}
          />
        )}
      </Box>
    ),
  });

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  return (
    <>
      {/* */}
      <MaterialReactTable table={table} />
    </>
  );
};

export default CustomTable;
